// extracted by mini-css-extract-plugin
export default {"light":"light--SpEaKbwYt0","dark":"dark--1xo8QwQMYF","items-container":"items-container--RYTngep9Z5","itemsContainer":"items-container--RYTngep9Z5","items":"items--AVi3ArRNHt"};